import { useState } from "react";
import { notifyConsumer } from "@/lib/s2tApi";
import { CheckCircle2, Loader2 } from "lucide-react";

export const ConsumerWaitlist = ({ onOpenLegal }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | loading | done | error
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    setState("loading");
    try {
      await notifyConsumer({ email: email.trim(), source: "source2table.com/join" });
      setState("done");
    } catch (err) {
      setState("error");
      setError(err.message);
    }
  };

  if (state === "done") {
    return (
      <div data-testid="consumer-success" className="text-center py-8">
        <CheckCircle2 size={48} className="mx-auto text-[#4A6B41]" />
        <h3 className="mt-4 font-sans font-extrabold text-2xl text-[#1C241B]">
          You're on the list!
        </h3>
        <p className="mt-2 text-[#5A6757]">
          We'll email you the moment Source2Table opens in your area.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="consumer-waitlist-form" className="space-y-4">
      <div>
        <label className="block text-sm font-semibold text-[#2F4829] mb-1.5">
          Email address
        </label>
        <input
          data-testid="consumer-email-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="w-full rounded-xl border border-[#D8E0D5] bg-white px-4 py-3 text-[#1C241B] outline-none focus:border-[#4A6B41] focus:ring-2 focus:ring-[#4A6B41]/20"
        />
      </div>

      <p className="text-xs text-[#5A6757] leading-relaxed">
        Some producers (wineries, craft breweries) list alcohol. Access to
        alcohol listings is restricted to adults 19+ and subject to local liquor
        laws. By joining you agree to our{" "}
        <button
          type="button"
          data-testid="consumer-terms-link"
          onClick={() => onOpenLegal("terms_of_service")}
          className="underline text-[#4A6B41] font-semibold"
        >
          Terms
        </button>{" "}
        and{" "}
        <button
          type="button"
          data-testid="consumer-privacy-link"
          onClick={() => onOpenLegal("privacy_policy")}
          className="underline text-[#4A6B41] font-semibold"
        >
          Privacy Policy
        </button>
        .
      </p>

      {error && (
        <p data-testid="consumer-error" className="text-sm text-red-600">
          {error}
        </p>
      )}

      <button
        data-testid="consumer-submit-btn"
        type="submit"
        disabled={state === "loading"}
        className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#4A6B41] text-[#F9F6F0] px-7 py-3.5 font-sans font-semibold hover:bg-[#2F4829] transition-colors disabled:opacity-60"
      >
        {state === "loading" && <Loader2 size={18} className="animate-spin" />}
        Join the waitlist
      </button>
    </form>
  );
};
